import { makeStyles } from '@mui/styles';
import { colors } from 'styles/theme';

export default makeStyles(() => ({
  root: {
    marginBottom: '8px',
    marginTop: '24px',
    width: '100%',
    '& .MuiFormHelperText-root': {
      color: colors.red120,
    },
  },
  header: {
    marginBottom: '8px',
  },
  label: {
    color: colors.black,
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '22px',
    display: 'flex',
  },
  subLabel: {
    fontWeight: 400,
    fontSize: 12,
    lineHeight: '16px',
    color: colors.grey70,
  },
  tooltipInfo: {
    marginLeft: 8,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  hint: {
    color: colors.amazdGrey0,
    fontSize: '12px',
    fontStyle: 'italic',
  },
}));
